import { type ViteEnvironment, getConfig } from "@bidbattles/bloks/config";

export function useViteEnvironment() {
	return getConfig().env;
}

export const isNotProduction = (env: ViteEnvironment) => env !== "production";
export const isProduction = (env: ViteEnvironment) => env === "production";
